/**
 * Kiyo Cart — Rabattfeld: Fokus beim Aufklappen weiterreichen.
 *
 * Problem: Ein Klick auf "+" (bzw. Enter auf "Rabatt") klappt das <details>
 * auf, der Fokus bleibt aber am <summary> haengen — dort, wo man gar nicht
 * tippen kann. Der Nutzer sieht ein offenes Eingabefeld, muss aber ein
 * zweites Mal klicken, um hineinzuschreiben. Fuer Tastaturnutzer noch
 * schlechter: der sichtbare Fokusring steht auf "Rabatt", waehrend das Feld
 * daneben leer wartet.
 *
 * Loesung: Nach dem Aufklappen den Fokus ins Eingabefeld setzen.
 *
 * Warum Event-Delegation auf document und kein Listener am Element:
 * Der Cart-Bereich wird bei jeder Aenderung per morphSection() neu gerendert.
 * Ein direkt gebundener Listener waere danach weg; ein Listener am document
 * ueberlebt jeden Morph. Aus demselben Grund liegt das Script NICHT im
 * Snippet — dort wuerde es bei jedem Morph erneut ausgefuehrt und die
 * Listener wuerden sich stapeln.
 *
 * Ausloeser ist das 'toggle'-Event, nicht ein Timer nach dem Klick: Das
 * <details> wechselt seinen Zustand erst NACH dem Click-Handler, und der
 * naheliegende requestAnimationFrame-Umweg ist unzuverlaessig — in einem
 * Hintergrund-Tab feuert rAF gar nicht (genau daran scheiterte die erste
 * Fassung im Test). 'toggle' feuert dagegen exakt beim Zustandswechsel.
 *
 * Das Klick-Flag ist die Absicherung dagegen, den Fokus zu klauen: Bei
 * aktivem Rabattcode steht das <details> per declarative-open dauerhaft offen
 * (siehe cart-summary.liquid) und toggelt bei Cart-Updates erneut. Ohne das
 * Flag wuerde der Fokus dann mitten im Tippen an anderer Stelle wegspringen.
 *
 * Details: THEME-CHANGES.md 2026-07-25.
 */
(function () {
  if (window.__kiyoCartDiscountFocus) return;
  window.__kiyoCartDiscountFocus = true;

  var openedByUser = false;

  // Capture: laeuft vor der Default-Action des <summary> und damit vor 'toggle'.
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      openedByUser = !!(target && target.closest && target.closest('.cart-discount__summary'));
    },
    true
  );

  // 'toggle' bubbelt nicht — daher ebenfalls in der Capture-Phase am document.
  document.addEventListener(
    'toggle',
    function (event) {
      if (!openedByUser) return;
      openedByUser = false;

      var details = event.target;
      if (!details || !details.matches || !details.matches('details')) return;
      if (!details.hasAttribute('open')) return;

      var input = details.querySelector('.cart-discount__input');
      // offsetParent === null: Bei aktivem Code ist die Eingabezeile per CSS
      // ausgeblendet (nur die Pille ist sichtbar) — dann gibt es nichts zu fokussieren.
      if (!input || input.disabled || input.offsetParent === null) return;

      input.focus();
    },
    true
  );
})();
